import React from 'react';

const ProfilePicture = ({ src, alt, className }) => {
    // Function to transform Cloudinary URL for better quality/performance
    const getOptimizedImageUrl = (url) => {
        if (!url || !url.includes('cloudinary.com')) return url;
        
        // Add Cloudinary transformations
        return url.replace('/upload/', '/upload/c_fill,g_face,h_400,w_400/');
    };

    return (
        <div className={`profile-picture-container ${className || ''}`}>
            {src ? (
                <img
                    src={getOptimizedImageUrl(src)}
                    alt={alt}
                    className="profile-image"
                    onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = '/default-user-icon.svg';
                    }}
                />
            ) : (
                <img
                    src="/default-user-icon.svg"
                    alt="Default Profile"
                    className="profile-image default-icon"
                />
            )}
        </div>
    );
};

export default ProfilePicture; 